import { currencies } from './currencies';

export const getSign = (currency) => {
  let s = currencies.find(c => c.code === currency);
  return s ? s.sign : '$';
}